var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tip)?_c('div',{staticClass:"ai-box"},[_c('span',{staticClass:"ai-tag"},[_vm._v("AI")]),_vm._v(" "),_c(_setup.ExpandableText,{staticClass:"ai-text",attrs:{"content":_vm.tip,"max-lines":1,"line-height":20}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }